// Fix for "Change location" link in cart drawer
// This script uses Alpine.js evaluate function to properly handle drawer state
(function() {
  // Wait for Alpine.js to be fully initialized
  document.addEventListener('alpine:initialized', function() {
    // Create a function to find and fix the "Change location" links
    function fixChangeLocationLinks() {
      // Find the cart drawer
      const cartDrawer = document.querySelector('[x-show="cart_drawer"]');
      if (!cartDrawer || window.getComputedStyle(cartDrawer).display === 'none') {
        return; // Cart drawer not visible, nothing to do
      }
      
      // Find all text containing "Change location" within the cart drawer
      const nodes = [];
      const walker = document.createTreeWalker(
        cartDrawer,
        NodeFilter.SHOW_TEXT,
        { acceptNode: node => node.textContent.includes('Change location') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT }
      );
      
      while (walker.nextNode()) {
        nodes.push(walker.currentNode);
      }
      
      // Find corresponding clickable elements
      const clickableLinks = [];
      nodes.forEach(textNode => {
        const element = textNode.parentElement;
        const closestLink = element.closest('a, button');
        if (closestLink) {
          clickableLinks.push(closestLink);
        }
      });
      
      // Process each link
      clickableLinks.forEach(link => {
        // Skip if already processed
        if (link.getAttribute('data-location-fixed') === 'true') {
          return;
        }
        
        // Mark as processed
        link.setAttribute('data-location-fixed', 'true');
        
        // Clone the link to remove existing handlers
        const newLink = link.cloneNode(true);
        
        // Remove any existing click handlers
        ['@click', 'x-on:click', 'x-bind:click', 'onclick'].forEach(attr => {
          if (newLink.hasAttribute(attr)) {
            newLink.removeAttribute(attr);
          }
        });
        
        // Add our custom click handler
        newLink.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Use Alpine.evaluate to set cart_drawer to false (preferred method)
          if (window.Alpine && window.Alpine.evaluate) {
            try {
              const cartDrawerEl = document.querySelector('[x-show="cart_drawer"]');
              if (cartDrawerEl && cartDrawerEl._x_dataStack) {
                window.Alpine.evaluate(cartDrawerEl, 'cart_drawer = false');
              }
            } catch (err) {
              // Fallback if Alpine.evaluate fails
              if (typeof window.cart_drawer !== 'undefined') {
                window.cart_drawer = false;
              }
            }
          } else {
            // Direct variable access if Alpine.evaluate isn't available
            if (typeof window.cart_drawer !== 'undefined') {
              window.cart_drawer = false;
            }
          }
          
          // Also try to enable body scrolling
          if (typeof window.enable_body_scrolling !== 'undefined') {
            window.enable_body_scrolling = true;
          }
          
          // Manually hide all cart drawer elements as a fallback
          document.querySelectorAll('[x-show="cart_drawer"]').forEach(el => {
            el.style.display = 'none';
          });
          
          // Wait for animations, then open location drawer
          setTimeout(function() {
            // Use Alpine.evaluate to set account_drawer to true (preferred method)
            if (window.Alpine && window.Alpine.evaluate) {
              try {
                const accountDrawerEl = document.querySelector('[x-show="account_drawer"]');
                if (accountDrawerEl && accountDrawerEl._x_dataStack) {
                  window.Alpine.evaluate(accountDrawerEl, 'account_drawer = true');
                }
              } catch (err) {
                // Fallback if Alpine.evaluate fails
                if (typeof window.account_drawer !== 'undefined') {
                  window.account_drawer = true;
                }
              }
            } else {
              // Direct variable access if Alpine.evaluate isn't available
              if (typeof window.account_drawer !== 'undefined') {
                window.account_drawer = true;
              }
            }
            
            // Manually show all account drawer elements as a fallback
            document.querySelectorAll('[x-show="account_drawer"]').forEach(el => {
              el.style.display = 'block';
              el.style.zIndex = '1000';
            });
          }, 300);
          
          return false;
        });
        
        // Replace the original link
        if (link.parentNode) {
          link.parentNode.replaceChild(newLink, link);
        }
      });
    }
    
    // Setup periodic checks for the cart drawer
    setInterval(fixChangeLocationLinks, 1000);
    
    // Also run when the page loads
    fixChangeLocationLinks();
    
    // Observer for dynamic content
    const observer = new MutationObserver(function(mutations) {
      // Check if cart drawer is visible after DOM changes
      const cartDrawer = document.querySelector('[x-show="cart_drawer"]');
      if (cartDrawer && window.getComputedStyle(cartDrawer).display !== 'none') {
        fixChangeLocationLinks();
      }
    });
    
    // Start observing the body
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  });
})();